var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower flower-x po",style:(_vm.getStyles)},[_c('div',{staticClass:"flower-y flower-pre"},[_c('div',{staticClass:"flower-z"},[_c('img',{staticClass:"flower-im",attrs:{"src":_vm.mode['im']}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }